/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { makeStyles } from '@mui/styles';
import NavigationBar from 'apollo-react/components/CustomNavigationBar';
import Toolbar from 'apollo-react/components/Toolbar';
import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import MobileDropdown from './MobileDropdown';
import { fetchAppNavigationFromServer } from '../../actions/NavigationActions';
import IQVIALogo from '../../assets/icons/iqvia_core.svg';
import { PILGRIM_TOP_MENU_HEIGHT } from '../../constants/SizeConstants';
import { HOME } from '../../constants/Urls';
import ChangeLanguageDialog from '../../containers/Dashboard/components/ChangeLanguageDialog';
import HelpTopicsDialog from '../../containers/HelpTopicsDialog';
import InstalledVersionsDialog from '../../containers/InstalledVersionsDialog';
import MenuDialog from '../../containers/MenuDialog';
import PatDialog from '../../containers/PatDialog';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getNetworkStatus } from '../../form-designer/selectors/common.selectors';
import { getMode } from '../../selectors/DashboardSelectors';
import { getAvailableNavigation } from '../../selectors/MasterSetupPageSelectors';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  root: {
    backgroundImage: 'radial-gradient(circle at 52% 0, #0076ae, #250056)',
    margin: 0,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    display: 'block',
    zIndex: 1200,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  rightContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  searchBar: {
    marginRight: '42px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: PILGRIM_TOP_MENU_HEIGHT,
  },
  logoImg: {
    cursor: 'pointer',
  },
  pill: {
    height: 24,
    borderRadius: 16,
    backgroundColor: '#ff9300',
    textAlign: 'center',
    fontFamily: 'Proxima Nova',
    fontSize: 12,
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.9,
    letterSpacing: 'normal',
    color: '#ffffff',
    padding: '0 10px',
    whiteSpace: 'nowrap',
    marginRight: 10,
  },
});

const MobilePilgrimTopMenu = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const navigation = useSelector(getAvailableNavigation, shallowEqual);
  const mode = useSelector(getMode);
  const isOnline = useSelector(getNetworkStatus);
  const translateString = useTranslation();

  useEffect(() => {
    if (!navigation.length) {
      dispatch(fetchAppNavigationFromServer());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, fetchAppNavigationFromServer, navigation]);

  return (
    <NavigationBar className={classes.root} position="relative">
      <Toolbar className={classes.toolbar}>
        <img
          className={classes.logoImg}
          src={IQVIALogo}
          alt="IQVIA Logo"
          width={137}
          height={25}
          onClick={() => {
            history.push(HOME);
          }}
          ui-ta={getUITA('IQVIALogo')}
        />
        <div className={classes.rightContainer}>
          {!isOnline && <div className={classes.pill}>{translateString('Offline')}</div>}
          <MobileDropdown />
        </div>
      </Toolbar>
      <PatDialog />
      <InstalledVersionsDialog />
      <HelpTopicsDialog />
      {mode === 'changeLanguage' && <ChangeLanguageDialog />}
      <MenuDialog />
    </NavigationBar>
  );
};

export default MobilePilgrimTopMenu;
